import { motion } from "framer-motion";
import React, { FC, useEffect } from "react";
import ReactDOM from "react-dom";
import styled from "styled-components";
import { theme } from "../config/theme";

export interface IModalProps {
  children?: React.ReactNode;
  show?: boolean;
  noBorder?: boolean;
  closeOnEsc?: boolean;
  onClose?: () => void;
}

const ModalBox = styled.div`
  left: 50%;
  max-height: 100%;
  position: fixed;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 500;
`;

const Backdrop = styled(motion.div)`
  position:         fixed;
  top:              0;
  left:             0;
  width:            100%;
  height:           100%;
  z-index:          500;
  background-color: ${theme.color.backdrop};
`;

const StyledModal = styled(motion.div)<IModalProps>`
  -webkit-overflow-scrolling: touch;
  align-items: left;
  background: ${theme.color.white};
  border-radius: 0.5rem;
  border: ${(p) => (p.noBorder ? "none" : "1px solid #D7DBDD")};
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  overflow-y: hidden;
  overflow: hidden;
  position: relative;
  z-index: 100;
`;

export const Modal: FC<IModalProps> = ({
  show,
  onClose,
  children,
  closeOnEsc,
  ...props
}) => {
  const escapeButtonPresses = (event: KeyboardEvent) => {
    if (event.code == "Escape") onClose();
  };

  useEffect(() => {
    if (closeOnEsc) document.addEventListener("keyup", escapeButtonPresses);
    return () => {
      document.removeEventListener("keyup", escapeButtonPresses);
    };
  }, []);

  const modal = (
    <>
      <Backdrop onClick={onClose}/>
      <ModalBox>
        <StyledModal
          {...props}
          initial={{ opacity: 0, scale: 0.75 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.35 }}
          exit={{ opacity: 0, scale: 0.75 }}
        >
          {children}
        </StyledModal>
      </ModalBox>
    </>
  );
  return show ? ReactDOM.createPortal(modal, document.body) : null;
};
